module.exports = __webpack_public_path__ + "static/media/AkkuratLight.23115632.ttf";